import gql from 'graphql-tag';

const createOrUpdateAuctionLocationMutation = gql`
  mutation createOrUpdateAuctionLocation(
    $auctionLocation: AuctionLocationInputObjectType!
  ) {
    createOrUpdateAuctionLocation(
      input: { auctionLocation: $auctionLocation }
    ) {
      success
      errors
    }
  }
`;

export default createOrUpdateAuctionLocationMutation;
